import { render, staticRenderFns } from "./address-card.vue?vue&type=template&id=ee351ec4&scoped=true"
import script from "./address-card.vue?vue&type=script&lang=js"
export * from "./address-card.vue?vue&type=script&lang=js"
import style0 from "./address-card.vue?vue&type=style&index=0&id=ee351ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee351ec4",
  null
  
)

export default component.exports